function useProps(props) {
  return props;
}

export { useProps };
